export default __webpack_public_path__ + "static/media/parceria.746f9879.jpg";